// extracted by mini-css-extract-plugin
module.exports = {"pTag":"AboutUs_pTag__Ra6ZH","h3Tag":"AboutUs_h3Tag__24UJ4"};